import { createFileRoute } from "@tanstack/react-router";
import { SubServicePage } from "@/components/SubServicePage";
import { SEO_SITE, hreflangLinks, ctaDesc, ctaTitle } from "@/lib/seo";

const meta = {"th":{"h1":"ภาษีเงินได้บุคคลธรรมดา (PIT) — ยื่น ภ.ง.ด.90/91/94","metaTitle":"ภาษีบุคคลธรรมดาไทย ภ.ง.ด.90/91/94 ต่างชาติ | NYC","metaDesc":"ยื่นภาษีเงินได้บุคคลไทย ภ.ง.ด.90/91/94 พร้อมสิทธิลดหย่อน LTF/RMF/SSF/ประกันชีวิต DTA 61 ประเทศ — เริ่มต้นง่าย ๆ แค่ทักไลน์ เราดูแลจนจบทุกขั้นตอน"},"en":{"h1":"Thai Personal Income Tax (PIT) — Filing PND.90/91/94","metaTitle":"Thai Personal Income Tax — Expats, DTA 61 countries | NYC","metaDesc":"Thai PIT filing PND.90/91/94 with LTF/RMF/SSF/insurance deductions and DTA relief across 61 countries. . — Start with a free review before you file anything."}} as const;

export const Route = createFileRoute("/en/tax/personal-pit")({
  head: () => {
    const url = `${SEO_SITE}/en/tax.personal-pit`;
    const c = meta.en;
    return {
      meta: [
        { title: ctaTitle(c.metaTitle, "/en/tax/personal-pit", "en")},
        { name: "description", content: ctaDesc(c.metaDesc, "/en/tax/personal-pit", "en")},
        { property: "og:title", content: ctaTitle(c.metaTitle, "/en/tax/personal-pit", "en")},
        { property: "og:description", content: ctaDesc(c.metaDesc, "/en/tax/personal-pit", "en")},
        { property: "og:url", content: url },
        { property: "og:type", content: "website" },
        { property: "og:locale", content: "en_US" },
        { name: "twitter:card", content: "summary_large_image" },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks("/tax.personal-pit", "/en/tax.personal-pit")],
    };
  },
  component: () => <SubServicePage slug="tax/personal-pit" locale="en" />,
});
